
export class Supplier {
   _id: string;
   isActive: boolean;
   isDelete: boolean;
   name: string;
   profile: string;
   email: string;
   phone: string;
   gender: string;
   branch: string;
   company: string;
   createdDate: Date;
   modifiedDate: Date;
   createdBy: string;
   modifiedBy: string;
}

